import React, { useEffect, useState } from 'react';

import { Typography, notification, Card, Divider, Upload, Button, Row, Col, Space } from 'antd';
import { EllipsisOutlined, UploadOutlined, CaretLeftOutlined } from '@ant-design/icons';

import { FormattedMessage, useIntl } from 'react-intl';

import _service from '@netuno/service-client';

import config from '../../../../../../config/config.json';

import '../../../Waste/index.less';

import ToProduceModal from './Modal'

const langContext = 'reserved-area.marketplace';

const { Meta } = Card;
const { Text } = Typography;

export default ({ wasteTypeUID, radius, setShowMarketplaceWasteType }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalUID, setModalUID] = useState(null);
    useEffect(() => {
        setLoading(true);
        _service({
            method: 'GET',
            url: '/marketplace/waste/produce/list',
            data: {
                waste_type_uid: wasteTypeUID,
                radius: radius
            },
            success: (response) => {
                setData(response.json);
                setLoading(false);
            },
            fail: (e) => {
                setLoading(false);
                notification['error']({
                    message: 'Não foi possivel carregar os dados.',
                    description: e.response.json.error,
                });
            }
        });
    }, []);

    const intl = useIntl();

    const onShowModal = (item) => {
        setIsModalVisible(true);
        setModalUID(item.uid);
    }

    const onModalClose = () => {
        setIsModalVisible(false);
    }

    const uploadCustomRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess("ok");
        }, 0);
    };

    const uploadBeforeValidation = (file) => {
        const isPhoto = file.type === 'image/jpg' || file.type === 'image/jpeg';
        if (!isPhoto) {
            notification["error"]({
                message: 'Ficheiro Inválido',
                description: 'Apenas é permitido ficheiro de imagem do tipo JPG.',
            });
        }
        return isPhoto || Upload.LIST_IGNORE;
    };

    return (
        <div className='marketplace__waste__type__card'>
            <Button
                title="Voltar"
                className="back-button"
                type="link"
                onClick={() => setShowMarketplaceWasteType(true)}
            ><CaretLeftOutlined /><FormattedMessage id={`${langContext}.button.back`} /></Button>
            <div>
                <Row gutter={16, 16} justify="start" >
                    {data.map((item) => (
                        <Space size={[8, 16]} wrap>
                            <Col xs={20} sm={4} md={8} lg={8} xl={{ span: 6, offset: 1 }}>
                                <Card
                                    style={{ width: 300 }}
                                    cover={
                                        (item.waste_produce.photo) ?
                                            <img src={config.api.services + 'construction/waste/produce/photo?uid=' + item.waste_produce.uid + '&type=mini'} />
                                            : null
                                    }
                                    actions={[
                                        <Button
                                            title="Detalhes"
                                            className="detail-button"
                                            type="link"
                                            onClick={() => onShowModal(item)}
                                        >
                                            <FormattedMessage id={`${langContext}.button.detail`} />
                                        </Button>,
                                    ]}
                                >
                                    <Meta
                                        title={item.name}
                                    />
                                    <Divider />
                                    <p>{intl.formatMessage({ id: langContext + '.fields.description' })}: <Text strong>{item.waste_produce.waste_type.description[intl.locale.split('-')[0]]}</Text></p>
                                    <p>{intl.formatMessage({ id: langContext + '.fields.amount' })}: <Text strong>{item.waste_produce.amount} {item.waste_produce.measurement_unit.description[intl.locale.split('-')[0]]}</Text></p>
                                    <p>{intl.formatMessage({ id: langContext + '.fields.estimated-date' })}: <Text strong>{item.waste_produce.estimated_date}</Text></p>
                                </Card>
                            </Col>
                        </Space>
                    ))}
                </Row>
            </div>
            {isModalVisible && <ToProduceModal uid={modalUID} radius={radius} wasteTypeUID={wasteTypeUID} onClose={onModalClose} />}
        </div>
    )
}